import SearchBox from './search-box.jsx';
import './search-box.scss';

export default SearchBox;
